import { useState, useEffect } from 'react';
import imageUrlBuilder from '@sanity/image-url';

const PROJECT_ID = 'tmzmc62e';
const DATASET = 'production';

const builder = imageUrlBuilder({ projectId: PROJECT_ID, dataset: DATASET });

// Ohne limit werden alle Posts geladen
function buildApiUrl(limit) {
  const slice = limit ? `[0...${limit}]` : '';
  const query = `*[_type == "post"] | order(publishedAt desc)${slice}{
  _id, title, publishedAt, text, link, image
}`;
  return `https://${PROJECT_ID}.apicdn.sanity.io/v2024-01-01/data/query/${DATASET}?query=${encodeURIComponent(query)}`;
}

// Berücksichtigt Crop & Hotspot aus dem Studio
export function imageUrl(image) {
  return builder.image(image).width(800).fit('max').auto('format').url();
}

export function formatDate(iso) {
  return new Date(iso).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

// Liefert null solange geladen wird, danach ein Array (bei Fehler leer)
export function usePosts(limit) {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(buildApiUrl(limit))
      .then((res) => res.json())
      .then((data) => { if (!cancelled) setPosts(data.result || []); })
      .catch(() => { if (!cancelled) setPosts([]); });
    return () => { cancelled = true; };
  }, [limit]);

  return posts;
}
